export function cleanContent(content: string, getHTMLOutput?: boolean) {
    const text = content;

    const tag = document.createElement('div');
    tag.innerHTML = text;
    // remove global styles from the 3rd party resources HTML response;
    const styles = tag.querySelectorAll('style');

    if (styles.length > 0) {
        styles.forEach(el => el.remove());
    }

    return getHTMLOutput ? tag.innerHTML : tag.innerText;
}
